import { detectLocale } from '@/i18n/i18n-util';
import { navigatorDetector } from 'typesafe-i18n/detectors';
import type { Locales } from '@/i18n/i18n-types';

const LOCALE_STORAGE_KEY = 'korza-locale';

export const detectUserLocale = (): Locales => {
  // First check localStorage for saved preference
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored && ['en', 'pt'].includes(stored)) {
    return stored as Locales;
  }

  // Then check browser language
  const detected = detectLocale(navigatorDetector);

  // Ensure we only return supported locales
  return ['en', 'pt'].includes(detected) ? (detected as Locales) : 'en';
};

export const saveLocale = (locale: Locales): void => {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
};

export const getSupportedLocales = (): {
  code: Locales;
  name: string;
  flag: string;
}[] => [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
];

// We'll need to import this in components that need to change locale
export { loadLocaleAsync } from '@/i18n/i18n-util.async';
